import {Action} from '@ngrx/store';

export const GET_ALL_INVOICES = '[Invoices] Get All';
export const GET_ALL_INVOICES_SUCCESS = '[Invoices] Get All Success';
export const GET_ALL_INVOICES_ERROR = '[Invoices] Get All Error';

export const UPDATE_INVOICE = '[Invoice] Update';
export const UPDATE_INVOICE_SUCCESS = '[Invoice] Update Success';
export const UPDATE_INVOICE_ERROR = '[Invoice] Update Error';

export const APPROVE_INVOICE_PAYMENT = '[Invoice] Approve Payment';
export const APPROVE_INVOICE_PAYMENT_SUCCESS = '[Invoice] Approve Payment Success';
export const APPROVE_INVOICE_PAYMENT_ERROR = '[Invoice] Approve Payment Error';


export class GetAllInvoices implements Action {
  readonly type = GET_ALL_INVOICES;
}

export class GetAllInvoicesSuccess implements Action {
  readonly type = GET_ALL_INVOICES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllInvoicesError implements Action {
  readonly type = GET_ALL_INVOICES_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateInvoice implements Action {
  readonly type = UPDATE_INVOICE;

  constructor(public payload: any) {
  }
}

export class UpdateInvoiceSuccess implements Action {
  readonly type = UPDATE_INVOICE_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateInvoiceError implements Action {
  readonly type = UPDATE_INVOICE_ERROR;

  constructor(public payload: any) {
  }
}


export class ApproveInvoicePayment implements Action {
  readonly type = APPROVE_INVOICE_PAYMENT;

  constructor(public payload: any) {
  }
}

export class ApproveInvoicePaymentSuccess implements Action {
  readonly type = APPROVE_INVOICE_PAYMENT_SUCCESS;

  constructor(public payload: any) {
  }
}


export class ApproveInvoicePaymentError implements Action {
  readonly type = APPROVE_INVOICE_PAYMENT_ERROR;

  constructor(public payload: any) {
  }
}

export type InvoiceAction =
  GetAllInvoices
  | GetAllInvoicesSuccess
  | GetAllInvoicesError
  | UpdateInvoice
  | UpdateInvoiceSuccess
  | UpdateInvoiceError
  | ApproveInvoicePayment
  | ApproveInvoicePaymentSuccess
  | ApproveInvoicePaymentError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/actions/invoice.action.ts